// components/UserAvatarMenu.tsx
import React from "react";
import {Menu, Transition, MenuButton, MenuItems, MenuItem} from "@headlessui/react";
import useAuthStore from "../store/useAuthStore";
import useUserStore from "../store/useUserStore";
import SmartIcon from "./SmartIcon.tsx";
import {usePreferencesModal} from "../hooks/usePreferencesModal.tsx";
import {Avatar} from "@chakra-ui/react";
import {useCreditsStore} from "../store/useCreditsStore.ts";


const UserAvatarMenu = () => {
  const {logout} = useAuthStore();
  const {user} = useUserStore();
  const showPreferencesModal: (activeItemIdx?: number) => void = usePreferencesModal()

  const menu = [
    // {
    //   title: "Settings",
    //   icon: "settings-fill",
    //   onClick: () => showPreferencesModal(),
    // },
    {
      title: "Plan & billing",
      icon: "credit-card",
      onClick: () => useCreditsStore.getState().openPricing("billing"),
    },
    {
      title: "Log out",
      icon: "logout",
      onClick: logout,
    },
  ];

  return (
    <>
      <div className="relative z-20 mr-8 lg:mr-6 md:static">
        <Menu>
          <MenuButton
            className="group relative w-12 h-12 rounded-full">
            <Avatar
              size="md"
              name={`${user?.firstName} ${user?.lastName}`}
              src={user?.avatarSasLink}
            />
          </MenuButton>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <MenuItems
              className="absolute top-full -right-5 w-[19.88rem] mt-[0.9375rem] p-4 bg-n-100 border border-n-200 rounded-2xl shadow-[0px_48px_64px_-16px_rgba(0,0,0,0.25)] md:-right-38 md:w-[calc(100vw-4rem)] dark:bg-n-700 dark:border-n-500">
              <div className="flex items-center mb-2">
                <div className="relative w-15 h-15">
                  <Avatar
                    size="md"
                    name={`${user?.firstName} ${user?.lastName}`}
                    src={user?.avatarSasLink}
                  />
                  <div
                    className="absolute right-2 bottom-2 w-4.5 h-4.5 bg-primary-2 rounded-full border-4 border-n-100 dark:border-n-700"
                  />
                </div>
                <div className="pl-4 mb-6">
                  <div className="h6">{`${user?.firstName} ${user?.lastName}`}</div>
                  {/*<div className="caption1 text-n-400">*/}
                  {/*  {user?.access.isClientAdmin ? "Client Admin" : "User"}*/}
                  {/*</div>*/}
                </div>
              </div>
              <div className="px-4 bg-n-200 rounded-xl dark:bg-n-600">
                {menu.map((item) => (
                  <MenuItem key={item.title}>
                    <button
                      type="button"
                      className="group flex items-center w-full h-12 base2 font-semibold transition-colors hover:text-brandPurple-500"
                      onClick={item.onClick}
                    >
                      <SmartIcon
                        className="mr-4 fill-n-400 transition-colors group-hover:fill-brandPurple-500"
                        name={item.icon}
                      />
                      {item.title}
                    </button>
                  </MenuItem>
                ))}
              </div>
            </MenuItems>
          </Transition>
        </Menu>
      </div>
      {/*<Modal*/}
      {/*  className="md:!p-0"*/}
      {/*  classWrap="max-w-[48rem] md:min-h-screen-ios md:rounded-none"*/}
      {/*  classButtonClose="hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400"*/}
      {/*  classOverlay="md:bg-n-100"*/}
      {/*  visible={visibleSettings}*/}
      {/*  onClose={() => setVisibleSettings(false)}*/}
      {/*>*/}
      {/*  <Settings items={settings} />*/}
      {/*</Modal>*/}
    </>
  );
};

export default UserAvatarMenu;
